// Import de bibliotecas principais
import React, { Fragment } from 'react'

// Import de elementos de estilização, componentes gerais e de layout
import './Default.module.scss'

export function Default() {
	return <Fragment></Fragment>
}
